module.exports = __webpack_public_path__ + "img/user.9d1efce8.png";